import { render, staticRenderFns } from "./DiagnosticLatestTable.vue?vue&type=template&id=6828ff09"
import script from "./DiagnosticLatestTable.vue?vue&type=script&lang=js"
export * from "./DiagnosticLatestTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports